import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { ORIGIN_EXTRAS, ORIGIN_LOTS, slugify } from "../../mock";

const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export default function RegionMap({ commodity, origins, active }) {
  const elRef = useRef(null);

  useEffect(() => {
    const ex = ORIGIN_EXTRAS[active.region];
    const map = L.map(elRef.current, { scrollWheelZoom: false, attributionControl: true }).setView(ex.coords, ex.zoom - 1);
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 18
    }).addTo(map);

    origins.forEach((o) => {
      const e = ORIGIN_EXTRAS[o.region];
      const isActive = o.region === active.region;
      const lots = ORIGIN_LOTS(commodity, o.region);
      const m = L.circleMarker(e.coords, { radius: isActive ? 14 : 9, color: "#f6f1e7", weight: 2, fillColor: isActive ? "#1f4a33" : "#b08a5f", fillOpacity: 0.95, className: `region-marker region-marker-${slugify(o.region)}` }).addTo(map);
      m.bindTooltip(`<strong>${esc(o.region)}</strong> · ${esc(o.altitude)}`, { direction: "top", offset: [0, -10], permanent: isActive });
      m.bindPopup(
        `<div style="min-width:180px"><p style="font-weight:600;margin:0">${esc(o.region)}</p><p style="font-size:12px;color:#555;margin:2px 0 0">${esc(e.towns)}</p>` +
        (lots.length ? `<p style="font-size:12px;margin:8px 0 0">Lots: ${esc(lots.map((l) => l.name).join(", "))}</p>` : "") +
        (isActive ? "" : `<a href="/origins/${commodity}/${slugify(o.region)}" style="display:block;margin-top:8px;font-size:12px;text-decoration:underline">Open region</a>`) + "</div>"
      );
    });

    return () => map.remove();
  }, [commodity, origins, active]);

  return (
    <div className="relative rounded-[2rem] overflow-hidden border border-[#10271a]/10 shadow-[0_30px_60px_-30px_rgba(16,39,26,0.5)] h-[420px] md:h-[520px]" data-testid="region-map">
      <div ref={elRef} className="h-full w-full" />
      <div className="absolute left-4 bottom-4 z-[500] bg-[#10271a]/80 backdrop-blur text-[#f6f1e7] text-[10px] tracking-[0.18em] uppercase px-3 py-2 rounded-full pointer-events-none">
        <span className="inline-block h-2 w-2 rounded-full bg-[#1f4a33] border border-[#f6f1e7] mr-2" />This region
        <span className="inline-block h-2 w-2 rounded-full bg-[#b08a5f] border border-[#f6f1e7] ml-4 mr-2" />Other {commodity} regions
      </div>
    </div>
  );
}
